import { render, staticRenderFns } from "./StripeCancellationFeeV2.vue?vue&type=template&id=5c2f8efb&scoped=true&"
import script from "./StripeCancellationFeeV2.vue?vue&type=script&lang=js&"
export * from "./StripeCancellationFeeV2.vue?vue&type=script&lang=js&"
import style0 from "./StripeCancellationFeeV2.vue?vue&type=style&index=0&id=5c2f8efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f8efb",
  null
  
)

export default component.exports